/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <React.Fragment>
    <g fill="currentColor">
      <path
        fillRule="evenodd"
        d="M7.75 0C5.679 0 4 1.679 4 3.75c0 1.0595.4394 2.0164 1.1459 2.6984C2.1467 7.518 0 10.3834 0 13.75v3l.005.1675C.0916 18.3583 1.2875 19.5 2.75 19.5h5V18h-5l-.1278-.0065C1.9919 17.9295 1.5 17.3972 1.5 16.75v-3l.0041-.2291C1.6247 10.1752 4.375 7.5 7.75 7.5c1.3873 0 2.6691.452 3.706 1.2168 1.5431 1.138 2.4999.2962 2.0616-.1435-.8529-.9496-1.9369-1.6874-3.1635-2.125C11.0606 5.7664 11.5 4.8096 11.5 3.75 11.5 1.679 9.821 0 7.75 0Zm0 6C8.9926 6 10 4.9926 10 3.75S8.9926 1.5 7.75 1.5 5.5 2.5074 5.5 3.75 6.5074 6 7.75 6Z"
        clipRule="evenodd"
      />
      <path d="M8.25 10h9c.6904 0 1.25.5596 1.25 1.25v6c0 .6904-.5596 1.25-1.25 1.25h-9c-.6904 0-1.25-.5596-1.25-1.25v-6c0-.6904.5596-1.25 1.25-1.25Z" />
      <path
        fillRule="evenodd"
        d="M8.25 8.5h9c1.5188 0 2.75 1.2312 2.75 2.75v6c0 1.5188-1.2312 2.75-2.75 2.75h-9c-1.5188 0-2.75-1.2312-2.75-2.75v-6c0-1.5188 1.2312-2.75 2.75-2.75Zm9 1.5h-9C7.5596 10 7 10.5596 7 11.25v6c0 .6904.5596 1.25 1.25 1.25h9c.6904 0 1.25-.5596 1.25-1.25v-6c0-.6904-.5596-1.25-1.25-1.25Z"
        clipRule="evenodd"
      />
      <path d="M11.936 11.7197a.75.75 0 0 0-1.0607 0L8.35 14.245l2.5203 2.5684.0835.0735a.7501.7501 0 0 0 .9771-.0634l.0735-.0835a.7501.7501 0 0 0-.0634-.9771l-1.4794-1.5089 1.4744-1.4737.0726-.0841a.7501.7501 0 0 0-.0726-.9765ZM13.5696 11.7197a.75.75 0 0 1 1.0607 0l2.5253 2.5253-2.5203 2.5684-.0834.0735a.7503.7503 0 0 1-.9772-.0634l-.0734-.0835a.75.75 0 0 1 .0633-.9771l1.4794-1.5089-1.4744-1.4737-.0726-.0841a.7503.7503 0 0 1 .0726-.9765Z" />
    </g>
    <defs></defs>
  </React.Fragment>,
  'SidebarDevportal'
);
